import type { FallingPair, PieceType } from "./model";
import { asPieceType } from "./model";

export interface Rng {
  readonly state: number;
  next(): number;
}

export function createRng(seed = Date.now()): Rng {
  let state = seed >>> 0;
  return {
    get state() {
      return state >>> 0;
    },
    next() {
      state = (Math.imul(1664525, state) + 1013904223) >>> 0;
      return state / 0x100000000;
    }
  };
}

export function randomType(rng: Rng, activeTypes: number): PieceType {
  return asPieceType(1 + Math.floor(rng.next() * activeTypes));
}

export function createRandomPair(rng: Rng, activeTypes: number, x = 2, y = 0): FallingPair {
  return {
    x,
    y,
    upperType: randomType(rng, activeTypes),
    lowerType: randomType(rng, activeTypes),
    orientation: 0
  };
}

export function hashSeed(...parts: number[]): number {
  let state = 2166136261;
  for (const part of parts) {
    state ^= part >>> 0;
    state = Math.imul(state, 16777619);
  }
  return state >>> 0;
}
